
import { computed, defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    placeholder: {
      type: String,
      default: null,
    },
    error: {
      type: String,
      default: null,
    },
  },
  setup(props, { emit }) {
    const modelValue = computed({
      get() {
        return props.value;
      },
      set(newValue) {
        emit('input', newValue);
      },
    });

    return {
      modelValue,
    };
  },
});
